<template>
  <div id="print">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
console.log(process.env.NODE_ENV)
export default {
  name: 'App',
  created() {
    // this.$axios.get('/category/all').then(res => {
    //   console.log(res)
    // })
  }
}
</script>

